export default __webpack_public_path__ + "static/media/background.3ce74c63.png";